import React, { useEffect, useRef, useState } from 'react';
import { LOCAL_STORAGE_USER_LOGIN_INFO, ORDER_BY, ResponseCode } from "@app/constants/Common";
import { requestGroupPipelineByStragyCompaignNextDVTJCUV } from "@pages/dvtjcuv/service/DVTJCUVFollowUpService";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import DVTJCUVPipelineNextStragyCompaignGroupItemList
    from "@pages/dvtjcuv/rundvtjcuv/DVTJCUVPipelineNextStragyCompaignGroupItemList";
import DVTJCUVEmailInviteModal, { EmailInviteMode } from "@pages/candidate/list/DVTJCUVEmailInviteModal";

const DVTJCUVPipelineNextStragyCompaignGroupList = (props) => {
    const [groups, setGroups] = useState([]);
    const [pipelinesByGroup, setPipelinesByGroup] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [selectedPipelines, setSelectedPipelines] = useState([]);
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);

    const { pipelineIds, parentTab, mode } = props
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const requestIdRef = useRef(0);

    const fetchAll = async (ids) => {
        const requestId = ++requestIdRef.current;
        setIsLoading(true);
        try {
            const groupRes = await requestGroupPipelineByStragyCompaignNextDVTJCUV({ pipeline_ids: ids, invite_mode: mode });
            if (requestId !== requestIdRef.current) return;
            const fetchedGroups = (groupRes && groupRes.content && groupRes.content.groups) || [];

            const allPipelineIds = [...new Set(
                fetchedGroups.flatMap(g => Array.isArray(g && g.pipeline_ids) ? g.pipeline_ids : [])
            )];

            let allPipelines = [];
            if (allPipelineIds.length > 0) {
                const pipeRes = await requestGetDVTJCUVPipeLineList({
                    search_conditions: {
                        parent_tab: parentTab && parentTab.id,
                        pipeline_ids: allPipelineIds,
                        unlimited: true
                    },
                    sort_columns: { created_date_time: ORDER_BY.DESC_UPDATE_DATE }
                });
                if (requestId !== requestIdRef.current) return;
                if (pipeRes && pipeRes.sts_code === ResponseCode.SUCCESS) {
                    allPipelines = (pipeRes.content && pipeRes.content.pipelines) || [];
                }
            }

            const bucketed = {};
            fetchedGroups.forEach((g, i) => {
                const key = `${g && g.g_next_fu_strategy_date_time}-${g && g.g_next_fu_campaign}-${i}`;
                const groupIds = new Set(Array.isArray(g && g.pipeline_ids) ? g.pipeline_ids : []);
                bucketed[key] = allPipelines.filter(p => p && groupIds.has(p.id));
            });

            setGroups(fetchedGroups);
            setPipelinesByGroup(bucketed);
        } finally {
            if (requestId === requestIdRef.current) {
                setIsLoading(false);
            }
        }
    };

    const visibleGroups = React.useMemo(
        () => (groups || [])
            .map((g, i) => ({
                ...g,
                __key: `${g && g.g_next_fu_strategy_date_time}-${g && g.g_next_fu_campaign}-${i}`
            }))
            .filter(g => (pipelinesByGroup[g.__key] || []).length > 0),
        [groups, pipelinesByGroup]
    );

    const getCandidateIds = (pipelines, currentMode) => {
        const isSendJobMode = currentMode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB
            || currentMode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU;
        const field = isSendJobMode ? 'cdd_receiver_id' : 'cdd_id';
        return [...new Set(pipelines.map(item => item[field]))];
    }

    const onEmailFU = async (pipelines) => {
        setSelectedPipelines(pipelines)
        setShowFollowUpModal(true)
    }


    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    const pipelineIdsKey = Array.isArray(pipelineIds) ? pipelineIds.join(',') : '';
    const parentTabId = parentTab && parentTab.id;

    useEffect(() => {
        if (pipelineIds && pipelineIds.length > 0) {
            fetchAll(pipelineIds).then()
        } else {
            setGroups([]);
            setPipelinesByGroup({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pipelineIdsKey, parentTabId, mode]);

    if (isLoading) {
        return <div className='text-center p-3 text-muted'>Loading...</div>;
    }

    if (visibleGroups.length === 0) {
        return <div className='text-center p-3 text-muted'>Không có dữ liệu</div>;
    }

    return (
        <>
            {visibleGroups.map((group) => (
                <DVTJCUVPipelineNextStragyCompaignGroupItemList
                    key={group.__key}
                    pipelineIds={group.pipeline_ids}
                    initialPipelines={pipelinesByGroup[group.__key]}
                    nextFUStrategy={group.g_next_fu_strategy_date_time}
                    nextFUCompaign={group.g_next_fu_campaign}
                    parentTab={parentTab}
                    onEmailFU={onEmailFU}
                    mode={mode}
                />
            ))}

            {showFollowUpModal &&
                <DVTJCUVEmailInviteModal candidateIds={getCandidateIds(selectedPipelines, mode ?? EmailInviteMode.INVITE_EMAIL_FU)}
                    pipelines={selectedPipelines}
                    mode={mode ?? EmailInviteMode.INVITE_EMAIL_FU}
                    onClose={() => setShowFollowUpModal(false)}
                    isShow={showFollowUpModal} />
            }
        </>
    )
}

export default DVTJCUVPipelineNextStragyCompaignGroupList;
